import { Component, h } from "preact";
import SliderControlRight from "./slider-control-right";
import SliderControlLeft from "./slider-control-left";
import { IConfiguration } from "../../../typings";

interface ISliderDivProps {
  small: boolean;
  active: boolean;
  slider: boolean;
  onLoad: Function;
  children: JSX.Element[];

  config: IConfiguration;
}

interface ISliderDivState {
  enableScroll: boolean;
  maxScroll: number;
  minScroll: number;
  scroll: number;
  activeLeft: boolean;
  activeRight: boolean;
}

export default class SliderDiv extends Component<
  ISliderDivProps,
  ISliderDivState
> {
  imagesLoaded: any;
  scrollableElement: HTMLElement;

  constructor(props: ISliderDivProps) {
    super(props);

    this.state = {
      enableScroll: false,
    } as ISliderDivState;

    this.checkImagesLoaded = this.checkImagesLoaded.bind(this);
    this.enableScroll = this.enableScroll.bind(this);
    this.updateScroll = this.updateScroll.bind(this);
    this.handleSliderLeftClick = this.handleSliderLeftClick.bind(this);
    this.setMaxScroll = this.setMaxScroll.bind(this);
    this.handleSliderRightClick = this.handleSliderRightClick.bind(this);
    this.setScrollableElement = this.setScrollableElement.bind(this);
  }

  componentDidMount(): void {
    this.setState({
      enableScroll: true,
      maxScroll: 1000,
      minScroll: 0,
      scroll: 0,
      activeLeft: false,
      activeRight: true,
    });

    window.addEventListener("resize", () => {
      this.enableScroll();
      this.setMaxScroll();
    });

    this.imagesLoaded = setInterval(() => {
      this.checkImagesLoaded();
    }, 1000);

    this.enableScroll();
    this.setMaxScroll();
  }

  componentDidUpdate(prevProps: ISliderDivProps): void {
    if (this.props.active === true && prevProps.active === false) {
      this.enableScroll();
      this.setMaxScroll();
    }
  }

  checkImagesLoaded(): void {
    if (this.scrollableElement) {
      const images: NodeListOf<HTMLImageElement> =
        this.scrollableElement.querySelectorAll("img");
      if (images.length > 0) {
        let loaded: number = 0;
        images.forEach((img: HTMLImageElement) => {
          if (img.complete === true) {
            loaded = loaded + 1;
          }
        });

        if (loaded === images.length) {
          this.enableScroll();
          this.setMaxScroll();
          clearInterval(this.imagesLoaded);
          this.props.onLoad();
        }
      } else {
        this.enableScroll();
        this.setMaxScroll();
        clearInterval(this.imagesLoaded);
        this.props.onLoad();
      }
    } else {
      clearInterval(this.imagesLoaded);
      this.enableScroll();
      this.setMaxScroll();
      clearInterval(this.imagesLoaded);
      this.props.onLoad();
    }
  }

  enableScroll(): void {
    let enableScroll: boolean = false;
    if (this.props.slider === true) {
      if (this.scrollableElement) {
        if (
          this.scrollableElement.clientWidth !==
          this.scrollableElement.scrollWidth
        ) {
          enableScroll = true;
        }
      }
    }

    if (enableScroll !== this.state.enableScroll) {
      this.setState({
        enableScroll,
      });
    }
  }

  setMaxScroll(): void {
    if (this.scrollableElement) {
      if (
        this.scrollableElement.scrollWidth &&
        this.scrollableElement.clientWidth
      ) {
        const maxScroll: number =
          this.scrollableElement.scrollWidth -
          this.scrollableElement.clientWidth;
        if (maxScroll !== this.state.maxScroll) {
          this.setState({
            maxScroll,
          });
        }
      }
    }
  }

  updateScroll(): void {
    if (this.state.maxScroll !== this.scrollableElement.scrollWidth) {
      this.enableScroll();
      this.setMaxScroll();
    }

    const scroll: number = this.scrollableElement.scrollLeft;

    let activeLeft: boolean = this.state.activeLeft;
    let activeRight: boolean = this.state.activeRight;
    if (scroll <= 0) {
      activeLeft = false;
      activeRight = true;
    } else if (scroll >= this.state.maxScroll) {
      activeLeft = true;
      activeRight = false;
    } else if (activeLeft !== true || activeRight !== true) {
      activeLeft = true;
      activeRight = true;
    }

    this.setState({
      scroll,
      activeLeft,
      activeRight,
    });
  }

  handleSliderLeftClick(): void {
    if (this.state.maxScroll === 1000) {
      this.setMaxScroll();
    }

    let scroll: number = this.state.scroll;
    const activeLeft: boolean = this.state.activeLeft;
    if (activeLeft === true) {
      scroll = scroll - 406;
      if (scroll <= 0) {
        scroll = 0;
      }

      this.scrollableElement.scrollLeft = scroll;
      // if (this.scrollableElement.scrollTo) {
      //   this.scrollableElement.scrollTo(scroll, 0);
      // } else {
      // }
    }
  }

  handleSliderRightClick(): void {
    if (this.state.maxScroll === 1000) {
      this.setMaxScroll();
    }

    let scroll: number = this.state.scroll;
    const activeRight: boolean = this.state.activeRight;

    if (activeRight === true) {
      scroll = scroll + 406;

      if (scroll >= this.state.maxScroll) {
        scroll = this.state.maxScroll;
      }

      this.scrollableElement.scrollLeft = scroll;
    }
  }

  setScrollableElement(element: HTMLElement): HTMLElement {
    if (!element) {
      return;
    }

    this.scrollableElement = element;

    this.scrollableElement.addEventListener("scroll", () => {
      this.updateScroll();
    });

    return element;
  }

  render(): JSX.Element {
    return (
      <div>
        {this.state.enableScroll === true && (
          <SliderControlLeft
            onClick={this.handleSliderLeftClick}
            active={this.state.activeLeft}
            small={this.props.small}
            config={this.props.config}
          />
        )}
        <div
          className="option__options slider--no-padding"
          ref={this.setScrollableElement}
        >
          <div className="flex flex-row">{this.props.children}</div>
        </div>
        {this.state.enableScroll === true && (
          <SliderControlRight
            onClick={this.handleSliderRightClick}
            active={this.state.activeRight}
            small={this.props.small}
            config={this.props.config}
          />
        )}
      </div>
    );
  }
}
